import { Skeleton } from '@mui/material';
import { NodeViewWrapper } from '@tiptap/react';
import { Image } from "antd";
import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import { addTaskAttachment } from '../../../../../../redux/tasks/actions';
import { makeGetSignedUrlSelector } from '../../../../../../redux/files/selectors';

const InlineImageEditorComponent = (props) => {
  const dispatch = useDispatch();

  const [deleted, setDeleted] = useState(false);
  const [signedUrl, setSignedUrl] = useState(null);

  const uploadFile = async () => {
    try {
      let signedUrl;
      let fileId;

      const { entityType, entityId, file } = props?.node?.attrs || {};

      switch (entityType) {
        case 'task': {
          const { signedUrl: url, fileId: id } = await dispatch(addTaskAttachment(file, entityId));
          signedUrl = url;
          fileId = id;
          break;
        }
        default: {
          console.warn('This entity type not supported yet!');
          props.deleteNode();
          setDeleted(true);
          return;
        }
      }

      if (signedUrl && fileId) {
        props.updateAttributes({
          fileId,
          file: null,
        });
        setSignedUrl(signedUrl);
      }
    } catch (e) {
      console.error(e);
      props.deleteNode();
      setDeleted(true);
    }
  };

  useEffect(() => {
    if (props?.signedUrl) {
      setSignedUrl(props?.signedUrl);
    } else {
      uploadFile();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // TODO: When message is not sent yet, but image was deleted from it, app needs to delete file from bucket

  const handleClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  return deleted ? null : (
    <NodeViewWrapper className="inline-image-container">
      <div className="inline-image-wrapper">
        {signedUrl ? (
          <Image
            className="inline-image"
            src={signedUrl}
            alt={`image-${props?.node?.attrs?.fileid}`}
            onClick={handleClick}
          />
        ) : (
          <Skeleton width={300} height={200} animation="pulse" variant="rectangular" sx={{ borderRadius: '4px' }} />
        )}
        <div className="hidden-selection-indicator-overlay" />
      </div>
    </NodeViewWrapper>
  );
};

const makeMapStateToProps = () => {
  const getSignedUrlSelector = makeGetSignedUrlSelector();

  return (state, ownProps) => ownProps?.node?.attrs?.fileId ? ({
    signedUrl: getSignedUrlSelector(state, { fileId: ownProps?.node?.attrs?.fileId }),
  }) : ({});
};

export default connect(makeMapStateToProps)(InlineImageEditorComponent);
